import { graphql } from "gatsby"
import React from "react"

export default function AltmetricBadge({ doi }: Queries.DoiFragment) {
  return doi ? (
    <div
      className="altmetric-embed mb-2 h-5 [&_a]:!flex"
      data-badge-type="1"
      data-doi={doi}
    />
  ) : null
}

export const fragment = graphql`
  fragment Doi on ContentfulResource {
    doi
  }
`
